import React from "react";
import "./CheckpointDeleteAccpage.scss";
import { useSearchParams } from "react-router-dom";

const CheckpointDeleteAccpage = () => {
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");
  return (
    <div>
      <p>{uid}</p>
    </div>
  );
};

export default CheckpointDeleteAccpage;
